module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-input-container md-theme-default md-has-select md-has-value",
    class: {
      'show-md-dark-mode': _vm.showMode
    }
  }, [_c('label', {
    attrs: {
      "for": 'active-user-' + _vm.slotNumber
    }
  }, [_vm._v("Active User #" + _vm._s(_vm.slotNumber))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.affiliateUser),
      expression: "affiliateUser"
    }],
    staticClass: "affiliate-slot-select-box",
    class: {
      'show-md-dark-mode': _vm.showMode
    },
    staticStyle: {
      "width": "100%",
      "border": "none",
      "outline": "none",
      "font-size": "16px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.affiliateUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeSlotAffiliate]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Open License")]), _vm._v(" "), _vm._l((_vm.availableList), function(usr) {
    return _c('option', {
      key: usr.uid,
      domProps: {
        "value": usr.uid
      }
    }, [_vm._v(_vm._s(usr.username))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d214db0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/manage-affiliation/affiliate-slot.vue
// module id = 1241
// module chunks = 21